//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('deviationTypeMenu', {
//        templateUrl: 'views/components/views/deviationTypeMenu/deviationTypeMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'deviationTypeMenuService', function ($stateParams, stateService, modalService, translateService, deviationTypeMenuService) {
    
//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let deviationTypeKeyno = $stateParams.deviationtype_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                deviationTypeNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('deviationtypelangs', { deviationtype_keyno: vm.model.menu.deviationtype_keyno }) }
//                ],
//                menu: {},
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//		    // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALL

//            async function loadMenu() {
//                vm.model.menu = (await deviationTypeMenuService.getMenu({ deviationtype_keyno: deviationTypeKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    deviationTypeMenuService.deleteItem({ deviationtype_keyno: vm.model.menu.deviationtype_keyno }).then(function (response) {
//                        if (response[0].errorcode !== '0') {
//                        	modalService.show({
//                        		type: 'warning',
//                        		title: translations.error,
//                        		message: response[0].errormessage,
//                        		buttons: [{
//                        			label: translations.ok,
//                        			cssClass: 'btn-warning',
//                        			action: function (dialogItself) {
//                        				dialogItself.close();
//                        				vm.model.lockedDelete = false;
//                        			}
//                        		}]
//                        	});
//                        } else {
//                        	vm.model.lockedDelete = false;
//                        	stateService.back();
//                        }
//                    }, function () {
//                        vm.model.lockedDelete = false;
//                    });
//                }, function () {
//                    vm.model.lockedDelete = false;
//                });
//            };

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadMenu();
//            };

//		    // #endregion ON INIT FUNCTION
//        }]
//    });
//})();
